export const CarrierOptimizationsActionTypes = {
    API_RESPONSE_SUCCESS: '@@carrier-optimizations/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@carrier-optimizations/API_RESPONSE_ERROR',
    GET_OPTIMIZED_CARRIERS: '@@carrier-optimizations/GET_OPTIMIZED_CARRIERS',
    GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL: '@@carrier-optimizations/GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL',
    GET_OPTIMIZED_TOTAL_COST: '@@carrier-optimizations/GET_OPTIMIZED_TOTAL_COST',
    GET_OPTIMIZED_AVG_COST: '@@carrier-optimizations/GET_OPTIMIZED_AVG_COST',
    GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE: '@@carrier-optimizations/GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE',
    GET_OPTIMIZED_SHIP_FROM_LOCATIONS: '@@carrier-optimizations/GET_OPTIMIZED_SHIP_FROM_LOCATIONS',
};
